import { Loader } from '@/view/shared/Loader';
import { setRedirectAfterLogin, useLogtoStarting } from '@/viewmodel/features/user';
import { selectIsLoaded, selectIsLoading } from '@/viewmodel/features/user';
import { useLogto } from '@logto/react';
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export function ProtectedRouteBilling({ children }: { readonly children: ReactNode }) {
  const isLoading = useSelector(selectIsLoading);
  const isLoaded = useSelector(selectIsLoaded);
  const { isAuthenticated } = useLogto();
  const isLogtoStarting = useLogtoStarting();
  const location = useLocation();

  if (isLogtoStarting) return <Loader />;
  if (!isAuthenticated) {
    setRedirectAfterLogin(location.pathname + location.search);
    return <Navigate to="/" replace />;
  }
  if (isLoading || !isLoaded) return <Loader />;

  return <>{children}</>;
}
